<template>
    <div>
        <b-modal
            id="initiate-review-popup"
            ref="modal"
            :title="title"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            modal-class="hide-footer"
            :hide-header-close="loading"
            hide-footer
            @hidden="onHidden"
        >
            <p class="custom-risk-override">
                {{ description }}
            </p>
            <div class="col-md-12 action-buttons">
                <button
                    :class="['btn btn-primary', { disabled: loading }]"
                    type="submit"
                    @click="initiateProcess()"
                >
                    <span class="btn-text">{{ buttonLabel }}</span>
                    <span class="loader"></span>
                </button>
                <button
                    class="btn btn-link"
                    type="button"
                    :disabled="loading"
                    @click="onHidden"
                >
                    <span class="btn-text">Cancel</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, //
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        alertRecord(value) {
            if (value !== null && value !== undefined) {
                this.id = value._id
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(val) {
            if (val) {
                this.onHidden()
            }
        },
    }, // End of watch
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'hidePopup',
            'dataSegmentId',
            'alertRecord',
            'hasScopes',
        ]),
        title() {
            if (this.hasScopes('unlock-alerts')) {
                return 'Unlock Alert'
            }
            return 'Initiate Review'
        },
        description() {
            if (this.hasScopes('unlock-alerts')) {
                return 'Are you sure you want to unlock this alert?'
            }
            return 'Are you sure you want to initiate review process of this customer profile?'
        },
        buttonLabel() {
            if (this.hasScopes('unlock-alerts')) {
                return 'Yes, Unlock Alert'
            }
            return 'Yes, Initiate Review'
        },
    }, // End of computed
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            id: null,
        }
    }, // End of data
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async initiateProcess() {
            try {
                this.$store.commit('setLoading', true)
                let params = {
                    id: this.alertRecord._id,
                    dataSegmentId: this.dataSegmentId,
                }
                // initiate review process for this alert
                let resourceApi = new resource('alerts/initiate-review')
                if (this.hasScopes('unlock-alerts')) {
                    resourceApi = new resource('alerts/unlock-alert')
                }
                let { data } = await resourceApi.update(params.id, params)
                if (data) {
                    await this.$store.commit('setAlertRecord', data.data)
                    this.$store.commit('setSuccess', data.message)
                }
                this.$store.commit('setRefreshProfile', true)
                await this.$router
                    .push({
                        name: 'customer-information',
                        params: {
                            id: data.data.customerId,
                        },
                    })
                    .catch(() => {})
            } catch (error) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error)
                //console.log(error, 'There is an error on initiate review')
            }
        },

        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    }, // End of methods
}
</script>
